export default "__VITE_ASSET__9CABfYnO__"